// src/components/ToastContainer.tsx
import { useState, useEffect } from 'react';
import { subscribeToToasts } from '../lib/toast';
import './ToastContainer.css';

interface Toast {
  id: number;
  message: string;
}

const TOAST_DURATION_MS = 4000;

export function ToastContainer() {
  const [toasts, setToasts] = useState<Toast[]>([]);

  useEffect(() => {
    return subscribeToToasts((message) => {
      const id = Date.now() + Math.random();
      setToasts((current) => [...current, { id, message }]);
      setTimeout(() => {
        setToasts((current) => current.filter((t) => t.id !== id));
      }, TOAST_DURATION_MS);
    });
  }, []);

  if (toasts.length === 0) return null;

  return (
    <div className="toast-container">
      {toasts.map((t) => (
        <div key={t.id} className="toast">{t.message}</div>
      ))}
    </div>
  );
}
